import { useSingleType } from "./content";

/**
 * Dados de contato do single type `contato`. Usados pela página /contato, pelo
 * rodapé e pelo botão flutuante de WhatsApp -- um único fetch atende os três.
 */
export const CONTATO_DEFAULTS = {
  titulo: "Fale com a Bivver",
  subtitulo:
    "Tire suas dúvidas ou peça mais informações sobre os nossos empreendimentos.",
  labelWhatsapp: "WhatsApp",
  whatsapp: "5547991674662",
  whatsappLabel: "(47) 99167-4662",
  whatsappMensagem:
    "Olá! Encontrei o site da Bivver e gostaria de mais informações.",
  whatsappBotao: "Fale Conosco",
  labelEmail: "E-mail",
  email: "comercial@bivver.com.br",
  labelEndereco: "Endereço",
  enderecoCurto: "Balneário Piçarras / SC",
  tituloFormulario: "Deixe sua mensagem",
  leadChamada:
    "Ficou interessado neste Bivver? Deixe suas informações e em breve entraremos em contato.",
  leadBotao: "Quero receber a tabela",
  leadSucesso: "Recebemos seu contato! Em breve um corretor fala com você.",
  textoBotao: "Enviar mensagem",
  mensagemSucesso: "Recebemos sua mensagem! Em breve entramos em contato.",
  mensagemErro:
    "Não foi possível enviar agora. Tente novamente ou fale pelo WhatsApp.",
  emailDestino: "comercial@bivver.com.br",
};

/** Monta o link wa.me a partir do número e da mensagem cadastrados. */
export function whatsappLink(numero, mensagem) {
  const digits = (numero || CONTATO_DEFAULTS.whatsapp).replace(/\D/g, "");
  const text = encodeURIComponent(mensagem || CONTATO_DEFAULTS.whatsappMensagem);
  return `https://wa.me/${digits}?text=${text}`;
}

export function useContato() {
  return useSingleType("/contato", CONTATO_DEFAULTS);
}
